import { Action } from "@iva/store-utils";

type LogItem = {
    timestamp: Date;
    rid: string;
    emitter: string;
    event: string;
    payload: any;
};
// State definition
type LoggingState = {
    messages: LogItem[];
};

// Action types definition
enum LoggingActionTypes {
    LOG_ITEM = "@@logging/LOG_ITEM",
}

// Actions definition
type LogItemAction = Action<LoggingActionTypes.LOG_ITEM, LogItem>;
type LoggingActions = LogItemAction;
export { LoggingActions };
export { LogItemAction };
export { LoggingActionTypes };
export { LoggingState };
export { LogItem };
